import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=de30740e&scoped=true&"
import script from "./NewsDetails.vue?vue&type=script&lang=js&"
export * from "./NewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetails.vue?vue&type=style&index=0&id=de30740e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de30740e",
  null
  
)

export default component.exports